import { yesNoUI } from 'platform/forms-system/src/js/web-component-patterns';
import fullSchema from 'vets-json-schema/dist/21-526EZ-ALLCLAIMS-V2-schema.json';
import { WaiverMilitaryRetiredPayDescription } from '../../components/additionalInformation/waiverMilitaryRetiredPay';
import ConfirmationMilitaryRetiredPayWaiver from '../../components/confirmationFields/ConfirmationMilitaryRetiredPayWaiver';

const { servicePay } = fullSchema.properties;

export default {
  uiSchema: {
    'ui:confirmationField': ConfirmationMilitaryRetiredPayWaiver,
    'ui:description': WaiverMilitaryRetiredPayDescription,
    servicePay: {
      isWaivingVaBenefitsForMilitaryRetiredPay: yesNoUI({
        title: 'Do you want to receive VA disability compensation?',
        tile: true,
        yesNoReverse: true,
        labels: {
          Y: 'Yes, I want to receive VA disability compensation.',
          N: 'No, I don’t want to receive VA disability compensation.',
        },
        descriptions: {
          Y: 'I understand my retired pay will be reduced accordingly.',
          N: 'I want to keep my full retired pay. I understand I will stop receiving any VA disability compensation.',
        },
        required: () => true,
      }),
    },
  },
  schema: {
    type: 'object',
    required: ['servicePay'],
    properties: {
      servicePay: {
        type: 'object',
        required: ['isWaivingVaBenefitsForMilitaryRetiredPay'],
        properties: {
          isWaivingVaBenefitsForMilitaryRetiredPay:
            servicePay.properties.isWaivingVaBenefitsForMilitaryRetiredPay,
        },
      },
    },
  },
};
